import { Controller } from 'react-hook-form';
import { StyleProp, ViewStyle } from 'react-native';
import { CheckboxOption } from '../crop-circle/Components/CheckboxOption';

type ControlledCheckboxItemProps = {
  control: any;
  name: string;
  label: string;
  position: 'leading' | 'trailing';
  style?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<ViewStyle>;
  mode?: 'android' | 'ios';
  disabled?: boolean;
};

export const ControlledCheckboxItem = (props: ControlledCheckboxItemProps) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      render={({ field: { onChange, value } }) => (
        <CheckboxOption
          mode="checkbox"
          state={value ? 'checked' : 'unchecked'}
          label={props.label}
          onPress={() => onChange(!value)}
          disabled={props.disabled}
        />
      )}
    />
  );
};
